import { RefObject, useEffect } from 'react'

function useOnClickOutside<T extends HTMLElement>(
  ref: RefObject<T>,
  handler: (event: MouseEvent) => void
): void {
  const onClickOutside = (e): void => {
    if (!ref.current?.contains(e.target)) {
      handler(e)
    }
  }

  useEffect(() => {
    document.addEventListener('mousedown', onClickOutside)
    return () => {
      document.removeEventListener('mousedown', onClickOutside)
    }
  }, [])
}

export default useOnClickOutside
